import { render, staticRenderFns } from "./BingoCard.vue?vue&type=template&id=6eb0f584"
import script from "./BingoCard.vue?vue&type=script&lang=js"
export * from "./BingoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports